import { allLangs } from '@config/languages';
import { WuLayoutHeaderMenuDropdown } from '@layout/components/WuLayoutHeaderMenuDropdown';
import { layoutStyle } from '@layout/styles';
import { Button, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import useLocales from '@theme/hooks/useLocales';
import React from 'react';
import { useGlobalDIContext } from '@context/GlobalDIContext';

function WuLayoutHeaderLang() {
  const { TranslationAdapter } = useGlobalDIContext();
  const { unsafeT } = TranslationAdapter();
  const { onChangeLang, currentLang } = useLocales();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = !!anchorEl;
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectLanguage = (lang: string) => {
    onChangeLang(lang);
    handleClose();
  };

  return (
    <>
      <Button
        id="lang-menu-button"
        aria-controls={open ? 'lang-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ mr: 2 }}
      >
        <Box component="img" src={currentLang.icon} sx={{ width: 40 }} />
      </Button>
      <WuLayoutHeaderMenuDropdown
        id="lang-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'profile-menu-button',
        }}
      >
        {allLangs.map((lang, index) => (
          <MenuItem
            key={index}
            sx={{ ...layoutStyle.menuDropdownLink, display: 'flex', alignItems: 'center' }}
            onClick={() => selectLanguage(lang.value)}
            disabled={currentLang.value === lang.value}
          >
            <Box component="img" src={lang.icon} sx={{ width: 20, marginRight: 2 }} />
            {unsafeT(lang.value)}
          </MenuItem>
        ))}
      </WuLayoutHeaderMenuDropdown>
    </>
  );
}

export default WuLayoutHeaderLang;
